module.exports = __webpack_public_path__ + "static/media/recommends_04_top5_candidates.9db1f7fc.png";